import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isOfflinePeopleDataEligibleForAccount } from "./isOfflinePeopleDataEligibleForAccount";

export type PDVStateDetails = {
    isOfflinePeopleDataViaPDVEnabledAllUp?: boolean;
    isOfflineSyncEnabled?: boolean;
    isPdvInMemoryEnabled?: boolean;
    isPdvEnabled?: boolean;
    isDataWorkerFaulted?: boolean;
    isOfflineDataFaulted?: boolean;
    isAccountFallbackToNoPGAL?: boolean;
    isSessionFallbackToNoPGAL?: boolean;
    isOfflineTemplateEnabled?: boolean;
    isMailboxSharedOrDelegate?: boolean;
};

export function isOfflinePeopleDataViaPDVEnabled(viewerMailboxInfo: MailboxInfo, pdvStateDetails: PDVStateDetails = {}): boolean {
    const isOfflinePeopleDataEligible = isOfflinePeopleDataEligibleForAccount(viewerMailboxInfo, pdvStateDetails);
    
    // We are intentionally not passing in MailboxInfo to below
    // flight checks because framework sync currently is
    // completely conditioned on the global settings mailbox account's
    // flights since they have some trouble at this time
    // to completely flight offline by account.
    const isPdvInMemoryEnabledFlag = isGlobalFeatureEnabled("peo-online-via-pdv");
    const isPdvEnabledFlag = isGlobalFeatureEnabled("peo-offline-via-pdv") || isPdvInMemoryEnabledFlag;
    const isOfflinePeopleDataViaPDVEnabledAllUp = isOfflinePeopleDataEligible && isPdvEnabledFlag;
    
    pdvStateDetails.isOfflinePeopleDataViaPDVEnabledAllUp = isOfflinePeopleDataViaPDVEnabledAllUp;
    pdvStateDetails.isPdvEnabled = isPdvEnabledFlag;
    pdvStateDetails.isPdvInMemoryEnabled = isPdvInMemoryEnabledFlag;
    
    return (isOfflinePeopleDataViaPDVEnabledAllUp ||
        (isPdvInMemoryEnabledFlag && !pdvStateDetails.isMailboxSharedOrDelegate));
}
